module.exports = __webpack_public_path__ + "static/media/loading-img.eda7e98f.png";